import { useMemo, type ReactNode } from 'react';
import {
  FluentProvider,
  IdPrefixProvider,
  type Theme,
} from '@fluentui/react-components';
import { buildMokoTheme, type MokoThemeConfig } from './themeConfig';
import { ToastHost } from '../Toast';
import { MokoThemeContext } from './ThemeContext';

type MokoThemeProviderProps = {
  children: ReactNode;
  idPrefix?: string;
} & (
  | { config: MokoThemeConfig; theme?: never }
  | { theme: Theme; config?: never }
);

export const MokoThemeProvider = ({
  children,
  config,
  theme: themeProp,
  idPrefix,
}: MokoThemeProviderProps) => {
  const theme = useMemo(
    () => themeProp ?? buildMokoTheme(config!),
    [themeProp, config]
  );

  const tree = (
    <MokoThemeContext.Provider value={theme}>
      <FluentProvider theme={theme}>
        <ToastHost />
        {children}
      </FluentProvider>
    </MokoThemeContext.Provider>
  );

  return idPrefix ? (
    <IdPrefixProvider value={idPrefix}>{tree}</IdPrefixProvider>
  ) : (
    tree
  );
};
